import { Injectable } from '@angular/core';
import { UserTypes } from '../enums/user-type.enum';
import { Router, CanActivate } from '@angular/router';
import { SecurityService } from '../../shared/utilities/security.service';

@Injectable()
export class RouteGuard implements CanActivate {
  constructor(private securityService: SecurityService, private router: Router) { }

  canActivate(): boolean {
    if (this.securityService.isAuthenticated() && this.securityService.getUserType() === UserTypes.petOwner) {
      this.router.navigateByUrl('owner');
      return true;
    } else if (this.securityService.isAuthenticated() && this.securityService.getUserType() === UserTypes.staff) {
      this.router.navigateByUrl('staff');
      return true;
    } else if (this.securityService.isAuthenticated() && this.securityService.getUserType() === UserTypes.externalUser) {
      this.router.navigateByUrl('external');
      return true;
    }
    this.router.navigateByUrl('auth/login');
    return false;
  }
}
